import {
  findUserTokenInStorage,
  logInWithPassword,
  login,
  logOut,
  setUserToken,
  fakeSessionLogIn,
  setFakeSession,
} from "./authActions";
import { Action } from "../../models/Action";
import { LOGIN_USER_URL } from "../../api/apiRoutes";
import { gaEvent } from "../../../utils/Analitics/ga";
import { GA_LOGIN } from "../../../utils/Analitics/gaEventsConsts";
import qs from "qs";

export const USER_TOKEN = "userToken";
const TOKEN_LIFETIME = 24 * 60 * 60 * 1000; // 24 godziny w milisekundach

const authMiddleware = (store: any) => (next: (action: Action<any>) => void) => (action: any) => {
  if (action.type === login.fulfilled.toString()) {
    const tokenData = action.payload;
    if (action.meta?.arg?.data?.rememberMe) {
      const tokenWithExpiry = {
        ...tokenData,
        expiresAt: new Date().getTime() + TOKEN_LIFETIME,
      };
      localStorage.setItem(USER_TOKEN, JSON.stringify(tokenWithExpiry));
    } else {
      sessionStorage.setItem(USER_TOKEN, JSON.stringify(tokenData));
    }
  }

  if (action.type === logInWithPassword.toString()) {
    store.dispatch(login({ url: LOGIN_USER_URL, data: action.payload }));
    const facilityIds = store.getState().config.facilityIds;
    gaEvent(facilityIds, "...", GA_LOGIN, {}, "");
  }

  if (action.type === logOut.toString()) {
    sessionStorage.removeItem(USER_TOKEN);
    localStorage.removeItem(USER_TOKEN);
    store.dispatch(fakeSessionLogIn());
  }

  if (action.type === login.fulfilled.toString()) {
    store.dispatch(setUserToken(action.payload));
  }

  if (action.type === findUserTokenInStorage.toString()) {
    let userToken = localStorage.getItem(USER_TOKEN);
    if (userToken) {
      const parsedUserToken = JSON.parse(userToken);
      // Jeżeli token ma pole expiresAt i jest wygasły, usuwamy go
      if (parsedUserToken.expiresAt && new Date().getTime() > parsedUserToken.expiresAt) {
        localStorage.removeItem(USER_TOKEN);
        userToken = null;
      } else {
        if (parsedUserToken.userName.substring(0, 5) === "GUEST") {
          store.dispatch(setFakeSession(parsedUserToken));
        } else {
          store.dispatch(setUserToken(parsedUserToken));
        }
      }
    }
    // Jeśli nie ma tokena w localStorage, sprawdzamy sessionStorage
    if (!userToken) {
      const sessionToken = sessionStorage.getItem(USER_TOKEN);
      if (sessionToken) {
        const parsedSessionToken = JSON.parse(sessionToken);
        if (parsedSessionToken.userName.substring(0, 5) === "GUEST") {
          store.dispatch(setFakeSession(parsedSessionToken));
        } else {
          store.dispatch(setUserToken(parsedSessionToken));
        }
      }
    }
  }

  if (action.type === fakeSessionLogIn.fulfilled.toString()) {
    const b2bToken = qs.parse(window.location.search.slice(1)).B2BSESSION as string;
    if (b2bToken) {
      const userToken = action.payload;
      if (userToken) {
        const overrideToken = { ...userToken, sessionToken: b2bToken, userName: b2bToken };
        sessionStorage.setItem(USER_TOKEN, JSON.stringify(overrideToken));
        store.dispatch(setUserToken(overrideToken));
      }
    } else {
      sessionStorage.setItem(USER_TOKEN, JSON.stringify(action.payload));
      store.dispatch(setFakeSession(action.payload));
    }
  }

  next(action);
};

export default authMiddleware;
